export const messages = {
  en: {
    salesRanking: {
      title: 'Sales Ranking',
      queryConditions: 'Query Conditions',
      productId: 'Product ID',
      productName: 'Product Name',
      salesVolume: 'Sales Volume',
      salesAmount: 'Sales Amount',
      returnQuantity: 'Return Quantity',
      returnAmount: 'Return Amount',
      createTime: 'Create Time',
      search: 'Search',
      reset: 'Reset',
      startTime: 'Start Time',
      endTime: 'End Time'
    }
  },
  zh: {
    salesRanking: {
      title: '销售排行',
      queryConditions: '查询条件',
      productId: '商品编号',
      productName: '商品名称',
      salesVolume: '销量',
      salesAmount: '销售金额',
      returnQuantity: '退货数量',
      returnAmount: '退货金额',
      createTime: '创建时间',
      search: '查询',
      reset: '重置',
      startTime: '开始时间',
      endTime: '结束时间'
    }
  }
}